export enum HwrcRoles {
  SuperAdmin = "SUPERADMIN",
  Admin = "ADMIN",
  LogisticsTeam = "LOGISTICSTEAM",
  Site = "SITE"
}
